<template>
    <Loader v-if="loading"/>
    <div class="order-view" v-else>
        <div class="wizard-component customer-infos">
            <slot name="headline"></slot>
            <br>
            <p>{{ $t('invoice-info.top.text') }}</p>
            <div class="inputs">
                <div class="input-container">
                    <p class="subject">{{ $t('invoice-info.label.full-name') }}</p>
                    <div class="input-inner">
                        <form>
                            <validation-provider rules="required" v-slot="{failed}" slim>
                                <input
                                    :class="{'has-error': failed}"
                                    type="text"
                                    autofill="off"
                                    autocomplete="false"
                                    v-on:keyup.enter="save()"
                                    v-model="full_name"
                                />
                            </validation-provider>
                        </form>
                    </div>
                </div>
                <div class="input-container">
                    <p class="subject">{{ $t('input.placeholder.vat_no') }}</p>
                    <div class="input-inner">
                        <form>
                            <input
                                type="text"
                                autofill="off"
                                autocomplete="false"
                                v-on:keyup.enter="save()"
                                v-model="vat_no"
                            />
                        </form>
                        <button style="margin-top: 0px;" class="purple" v-on:click="lookup()" :disabled="saving">
                            {{ $t('landlord.lookup-cvrapi.button') }}
                        </button>
                    </div>
                </div>
                <div class="input-container">
                    <p class="subject">{{ $t('input.placeholder.company') }}</p>
                    <div class="input-inner">
                        <form>
                            <input type="text" autofill="off" autocomplete="false" v-on:keyup.enter="save()"
                                   v-model="company"/>
                        </form>
                    </div>
                </div>
                <div class="input-container">
                    <p class="subject">{{ $t('invoice-info.label.address') }}</p>
                    <div class="input-inner">
                        <form>
                            <validation-provider rules="required" v-slot="{failed}" slim>
                                <input
                                    :class="{'has-error': failed}"
                                    type="text"
                                    autofill="off"
                                    autocomplete="false"
                                    v-on:keyup.enter="save()"
                                    v-model="address"/>
                            </validation-provider>
                        </form>
                    </div>
                </div>
            </div>
            <div class="inputs">
                <div class="input-container double">
                    <p class="subject">{{ $t('invoice-info.label.zipcode') }}</p>
                    <div class="input-inner">
                        <form>
                            <validation-provider rules="required|numeric" v-slot="{failed}" slim>
                                <input
                                    :class="{'has-error': failed}"
                                    type="text"
                                    autofill="off"
                                    autocomplete="false"
                                    v-on:keyup.enter="save()"
                                    v-model="zipcode"
                                />
                            </validation-provider>
                        </form>
                    </div>
                </div>
                <div class="input-container double">
                    <p class="subject">{{ $t('invoice-info.label.city') }}</p>
                    <div class="input-inner">
                        <form>
                            <validation-provider rules="required" v-slot="{failed}" slim>
                                <input
                                    :class="{'has-error': failed}"
                                    type="text" autofill="off"
                                    autocomplete="false"
                                    v-on:keyup.enter="save()"
                                    v-model="city"
                                />
                            </validation-provider>
                        </form>
                    </div>
                </div>
            </div>
            <div class="inputs">
                <button v-on:click="save()" :disabled="saving" class="purple">
                    <template v-if="!saving">{{ $t('invoice-info.button.send') }}</template>
                    <template v-else>{{ $t('saving') }} ...</template>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Loader from '../Loader.vue';


export default {
    data: () => ({
        loading: false,
        saving: false,
        user_info: {},
        full_name: '',
        company: '',
        address: '',
        zipcode: '',
        city: '',
        vat_no: '',
    }),
    components: {
        Loader
    },
    methods: {
        save() {
            Vue.api.patch('/order/userinfo', {
                name: this.full_name,
                address: this.address,
                city: this.city,
                zipcode: this.zipcode,
                company: this.company
            }, {
                before: () => this.loading = true,
                always: () => this.loading = false,
                callback: data => this.testFill()
            });
        },
        load() {
            Vue.api.post('/order/userinfo', {}, {
                before: () => this.loading = true,
                always: () => this.loading = false,
                callback: data => this.parse(data)
            });
        },
        lookup() {
            this.saving = true;
            axios({
                method: 'GET',
                url: 'https://cvrapi.dk/api?search=' + this.vat_no + '&country=dk',
                cancelToken: window.AuthorizationCancelSource.token,
            }).then(response => {
                this.company = response.data.name;
                this.address = response.data.address;
                this.zipcode = response.data.zipcode;
                this.city = response.data.city;
                this.email = response.data.email;

                this.saving = false;
            }).catch(e => {
                this.saving = false;
                if (e.response.status == 404) {
                    this.$swal(this.$t('landlord.lookup-cvrapi-notfound.error'), [], 'error');
                }
            });
        },
        parse(data) {
            this.full_name = data.full_name;
            this.company = data.company;
            this.address = data.address;
            this.zipcode = data.zipcode;
            this.city = data.city;
            this.vat_no = data.vat_no;

            this.testFill();
        },
        testFill() {
            if (this.full_name && this.address && this.zipcode && this.city) {
                this.$emit('completed');
            }
        }
    },
    created() {
        this.load();
    }
}
</script>
